"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const BlueskyIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M3.468 1.94C5.303 3.308 7.276 6.078 8 7.564c.724-1.486 2.697-4.256 4.532-5.622C13.855.955 16 .192 16 2.619c0 .485-.28 4.072-.444 4.654-.572 2.025-2.653 2.542-4.504 2.229 3.236.546 4.06 2.356 2.281 4.166-3.376 3.437-4.852-.863-5.23-1.964-.07-.202-.103-.297-.103-.216 0-.08-.033.014-.102.216-.379 1.101-1.855 5.4-5.231 1.964-1.778-1.81-.955-3.62 2.281-4.166-1.851.313-3.932-.204-4.504-2.229C.28 6.691 0 3.104 0 2.62 0 .192 2.145.955 3.468 1.941z"
  })))
});
BlueskyIcon.displayName = 'BlueskyIcon';
var _default = exports.default = BlueskyIcon;